









import { Component, Prop, Vue } from 'vue-property-decorator';
@Component
export default class SelectDropdown extends Vue {
  private isPopShow: boolean = false; // 隐藏下拉框
  private selectedDate: any = {
    value: '',
    id: '',
  };
  // 接收父组件的值
  @Prop() private label: any; // 输入框左侧文字
  @Prop() private placeholder: any;
  @Prop() private title: any; // 下拉框title
  @Prop() private columns: any; // 数据数组
  @Prop() private editVal: any; // 编辑的获取到的值
  public mounted() {
    if (this.editVal !== '') {
      this.selectedDate = this.editVal;
    } else {
      this.selectedDate = {};
    }
  }
  // 确定
  private onConfirm(value: any, index: any) {
    this.selectedDate.value = value.text;
    this.selectedDate.id = value.id;
    this.$emit('input', this.selectedDate);
    this.$emit('change', this.selectedDate);
    this.onCancel();
  }
  // 隐藏弹框
  private onCancel() {
    this.isPopShow = false;
  }
}
